import departements from "./departements-region.json";
export const getDepartementFromLongName = (deptLongName) => {
    if (!deptLongName) {
        return undefined;
    }
    return departements.find(dept => dept.dep_name.toLowerCase() === deptLongName.toLowerCase());
};
